const Rlx = {
    MailGun:{
        URL:{
            send: 'https://api-rolex-book-an-appointment.fly.dev/send'
        },        
        send: async function(data, callback){
            // console.error("❌ Change API Client before use it");
            try {
                const response = await fetch(this.URL.send, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });

                const result = await response.json();
                
                if (result.success) {
                    console.log("✅ Email sent successfully, check your email", result);
                    if(callback && typeof callback === 'function'){
                        callback();
                    }                    
                } else {
                    console.error("❌ Error in API:", result);
                }
            } catch (error) {
                console.error("❌ Error unknown:", error);
            }            
        }
    },
    BookAnAppointment:{
        section: null,
        currentStep: 1,
        purpose: null,
        store: null,
        date: null,
        day: null,
        time: null,
        time24: null,
        selectedDate: null,
        selectedTime: null,
        elementPurpose: null,
        elementSteps: null,
        elementBackStep: null,
        elementButtonForward: null,
        elementButtonSaveStore: null,
        elementButtonSaveForm: null,
        elementCalendarDate: null,
        elementCalendarTime: null,
        elementCalendarSave: null,
        elementSummaryPurpose: null,
        elementSummaryDate: null,
        elementSummaryAddress: null,
        elementAddToCalendar: null,
        init: function(){
            this.section = document.querySelector('.section-rlx-book-an-appointment');
            this.elementPurpose = document.querySelectorAll('[data-purpose]');
            this.elementSteps = document.querySelectorAll('[data-step]');
            this.elementBackStep = document.querySelectorAll('[data-back-step]');
            this.elementButtonForward = document.querySelectorAll('[data-button-forward]');
            this.elementButtonSaveStore = document.querySelector('[data-save-store]');
            this.elementButtonSaveForm = document.querySelector('[data-save-form]');
            this.elementCalendarDate = document.querySelectorAll('[data-calendar-date]');
            this.elementCalendarTime = document.querySelectorAll('[data-calendar-time]');
            this.elementCalendarSave = document.querySelector('[data-calendar-save]');
            this.elementSummaryPurpose = document.querySelector('[data-summary-purpose]');
            this.elementSummaryDate = document.querySelector('[data-summary-date]');
            this.elementSummaryAddress = document.querySelector('[data-summary-address]');
            this.elementAddToCalendar = document.querySelector('#rlx_add_to_calendar');

            this.saveStorage(null);

            this.elementPurpose.forEach(element => {
                element.addEventListener('click', (event) =>{
                    this.currentStep ++;
                    this.purpose = event.currentTarget.getAttribute('data-purpose');
                    this.saveStorage({purpose: this.purpose, trackingCode: { purpose: event.currentTarget.getAttribute('data-track') }});
                    this.showStep(this.currentStep);
                });
            });
            this.elementBackStep.forEach(element => {
                element.addEventListener('click', () =>{
                    this.backStep();
                });
            });
            this.elementButtonForward.forEach(element => {
                element.addEventListener('click', () =>{
                    this.forwardStep();
                });
            });

            this.elementButtonSaveStore.addEventListener('click', (event) =>{
                const btn = event.currentTarget;
                const storeError = btn.closest('.book-step').querySelector('[data-store-error]');

                if (btn.dataset.disabled === 'true') {
                    storeError.classList.remove('hidden');
                    return;
                }

                storeError.classList.add('hidden');
                this.currentStep ++;
                this.showStep(this.currentStep);
                const indexPos = btn.closest('.book-step').querySelector('#store_location').value;
                const storePos = JSON.parse(document.querySelector('#store_locations').textContent)[indexPos];
                this.store = storePos;
                this.saveStorage({store: this.store});
                Rlx.BookAnAppointment.bindCalendarSlot();
            });

            // Store selection: sync select <-> blocks, enable/disable button
            const storeBlocks = this.section.querySelectorAll('[data-store]');
            const storeSelect = this.section.querySelector('#store_location');
            const saveBtn = this.elementButtonSaveStore;

            const selectStore = (index) => {
                storeBlocks.forEach((block, i) => {
                    block.style.boxShadow = i === index ? '0 0 0 2px var(--rlx-green)' : '';
                });
                storeSelect.value = index;
                saveBtn.removeAttribute('data-disabled');
                const storeError = saveBtn.closest('.book-step').querySelector('[data-store-error]');
                if (storeError) storeError.classList.add('hidden');
            };

            // Auto-select if only one store
            if (storeBlocks.length === 1) {
                selectStore(0);
            }

            storeSelect.addEventListener('change', () => {
                selectStore(parseInt(storeSelect.value));
            });

            storeBlocks.forEach((block, index) => {
                block.addEventListener('click', () => {
                    selectStore(index);
                });
            });
        },
        bindCalendarSlot: function () {
            const self = Rlx.BookAnAppointment;

            if (self.elementCalendarSave) {
                self.elementCalendarSave.addEventListener("click", () => {
                    self.elementCalendarDate = document.querySelectorAll('[data-calendar-date]');
                    self.elementCalendarTime = document.querySelectorAll('[data-calendar-time]');

                    this.currentStep = 5;

                    const calendarDaySelected = Array.from(self.elementCalendarDate).find(el =>
                        el.getAttribute('data-selected-day') === 'true'
                    );

                    const calendartimeSelected = Array.from(self.elementCalendarTime).find(el =>
                        el.classList.contains("active")
                    );

                    self.date = calendarDaySelected.querySelector("[data-day]").getAttribute("data-day").split("|")[0];
                    self.day = calendarDaySelected.querySelector("[data-day]").getAttribute("data-day").split("|")[1];
                    self.time = calendartimeSelected.textContent;
                    self.time24 = calendartimeSelected.getAttribute("data-calendar-time");

                    const storage = self.getStorage();
                    self.saveStorage({ date: self.date, day: self.day, time: self.time, trackingCode: {...storage.trackingCode, date: self.date, day: self.day, time: self.time24 } });
                    self.showStep(self.currentStep);
                });
            }

            Rlx.BookAnAppointment.bindCalendarDate(self.elementCalendarDate, ['bg-rlx-green', 'text-white'], ['bg-white', 'text-brown-text', 'cursor-pointer'], (selected) => {
                self.selectedDate = selected;
            });
            Rlx.BookAnAppointment.bindSelectableElements(self.elementCalendarTime, ['bg-rlx-green', 'text-white', 'active'], ['bg-white', 'text-brown-text', 'cursor-pointer'], (selected) => {
                self.selectedTime = selected;
            });
        },
        backStep: function(){
            this.currentStep --;
            this.showStep(this.currentStep);
        },         
        forwardStep: function(){
            this.currentStep ++;
            this.showStep(this.currentStep);
        },        
        bindCalendarDate: function(elements, activeClasses, inactiveClasses, callback) {
            elements.forEach(element => {
                element.addEventListener('click', (event) => {
                    const selected = event.currentTarget;

                    elements.forEach(el => {
                        el.removeAttribute('data-selected-day');
                        el.classList.remove(...activeClasses);
                        el.classList.add(...inactiveClasses);
                    });

                    selected.setAttribute('data-selected-day', 'true');
                    selected.classList.remove(...inactiveClasses);
                    selected.classList.add(...activeClasses);

                    if (typeof callback === 'function') {
                        callback(selected);
                    }
                });
            });
        },
        bindSelectableElements: function(elements, activeClasses, inactiveClasses, callback) {
            elements.forEach(element => {
                element.addEventListener('click', (event) => {
                    const selected = event.currentTarget;

                    elements.forEach(el => {
                        el.classList.remove(...activeClasses);
                        el.classList.add(...inactiveClasses);
                    });

                    selected.classList.remove(...inactiveClasses);
                    selected.classList.add(...activeClasses);

                    if (typeof callback === 'function') {
                        callback(selected);
                    }
                });
            });
        },             
        showStep: function(step){
            this.elementSteps.forEach(element => {
                element.classList.add('hidden');
            });

            const currentStep = Array.from(this.elementSteps).find(
                element => element.getAttribute('data-step') === String(step)
            );

            if (currentStep) {
                currentStep.classList.remove('hidden');
            }
            Rlx.Utils.scrollTo(this.section);
        },
        saveStorage: function (value = null) {
            const key = 'RlxBookAnAppointment';

            if (value === null) {
                localStorage.removeItem(key);
                return;
            }

            const currentStorage = JSON.parse(localStorage.getItem(key)) || {};
            const data = {...currentStorage, ...value};
            localStorage.setItem(key, JSON.stringify(data));
        },
        getStorage: function () {
            return JSON.parse(localStorage.getItem('RlxBookAnAppointment'));
        },
        renderSummary: function(callback){
            const storeData = this.getStorage();
            this.elementSummaryPurpose.textContent = storeData.purpose;
            this.elementSummaryDate.textContent = `${ storeData.day } ${ Rlx.Utils.formatDate(storeData.date) } at ${ storeData.time }`;
            this.elementSummaryAddress.textContent = `${ storeData.store.address.replace(/<[^>]*>/g, "") }`;

            if(callback && typeof callback === 'function'){
                callback();
            }
        }    
    },
    cfg: {
        v: "7f4d8c91a2e34b"
    },
    cache: {
        timeout: 300,
        debounce: 500,

        assets: {
            app: 'N2Y0',
            vendor: 'ZDhj',
            theme: 'OTFh',
            chunk: 'MmUz',
            runtime: 'NGI='
        },

        classes: {
            container: 'rlx-cache-N2Y0',
            loading: 'rlx-runtime-ZDhj',
            hydrated: 'rlx-theme-OTFh'
        },

        predictiveSearch: true,
        cacheApi: false,
        transition: 'fade'
    },
    Utils:{
        formatDate: function(dateString){
            const date = new Date(dateString + "T12:00:00");
            return new Intl.DateTimeFormat("en-US", {
                day: "numeric",
                month: "long",
                year: "numeric",
                timeZone: "America/New_York",
            }).format(date);
        },
        addToGoogleCalendar: function(data){
            const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(data.title)}&details=${encodeURIComponent(data.description)}&location=${encodeURIComponent(data.address)}&dates=${data.start}/${data.end}`;
            window.open(url, "_blank");
        },
        getFormatDate: function(date){
            const now = new Date();
            const isoStringWithMilliseconds = now.toISOString(); 
            const formattedDate = isoStringWithMilliseconds.slice(0, 19) + 'Z'; 
            return formattedDate;
        },
		scrollTo: function(element){
            if (!element) return;

            const offsetTop = element.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
		}        
    }
}